export default __webpack_public_path__ + "static/media/Kaitlyn.61aa7932.jpg";